import { render, staticRenderFns } from "./ProspectsColumn.vue?vue&type=template&id=15efc2a0&scoped=true&"
import script from "./ProspectsColumn.vue?vue&type=script&lang=js&"
export * from "./ProspectsColumn.vue?vue&type=script&lang=js&"
import style0 from "./ProspectsColumn.vue?vue&type=style&index=0&id=15efc2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15efc2a0",
  null
  
)

export default component.exports